import { STEP_IDENTIFIER_NAME } from 'src/app/pages/startAPetition/pageContext';

import { AIAsksChoiceLoader, preloadAIAsksChoiceStep } from './components/AIAsksChoice';
import { AIDescriptionLoader, preloadAIDescriptionStep } from './components/AIDescription';
import { AIPromptLoader, preloadAIPromptStep } from './components/AIPrompt';
import { AIResultsDraftLoader, preloadAIResultsDraftStep } from './components/AIResultsDraft';
import { Ask, preloadAskStep } from './components/Ask';
import { DescriptionLoader, preloadDescriptionStep } from './components/Description';
import { Location, preloadLocationStep } from './components/Location';
import { Media, preloadMediaStep } from './components/Media';
import { PhoneCollection, preloadPhoneCollectionStep } from './components/PhoneCollection';
import { preloadPublishStep, Publish } from './components/Publish';
import { preloadReachStep, ReachLoader } from './components/Reach';

export const STEP_MAP = {
	[STEP_IDENTIFIER_NAME.AI_ASK_CHOICE]: {
		component: AIAsksChoiceLoader,
		preload: preloadAIAsksChoiceStep,
	},
	[STEP_IDENTIFIER_NAME.AI_PROMPT]: {
		component: AIPromptLoader,
		preload: preloadAIPromptStep,
	},
	[STEP_IDENTIFIER_NAME.AI_DESCRIPTION]: {
		component: AIDescriptionLoader,
		preload: preloadAIDescriptionStep,
	},
	[STEP_IDENTIFIER_NAME.AI_RESULTS_DRAFT]: {
		component: AIResultsDraftLoader,
		preload: preloadAIResultsDraftStep,
	},
	[STEP_IDENTIFIER_NAME.ASK]: {
		component: Ask,
		preload: preloadAskStep,
	},
	[STEP_IDENTIFIER_NAME.DESCRIPTION]: {
		component: DescriptionLoader,
		preload: preloadDescriptionStep,
	},
	[STEP_IDENTIFIER_NAME.LOCATION]: {
		component: Location,
		preload: preloadLocationStep,
	},
	[STEP_IDENTIFIER_NAME.MEDIA]: {
		component: Media,
		preload: preloadMediaStep,
	},
	[STEP_IDENTIFIER_NAME.PHONE_COLLECTION]: {
		component: PhoneCollection,
		preload: preloadPhoneCollectionStep,
	},
	[STEP_IDENTIFIER_NAME.PUBLISH]: {
		component: Publish,
		preload: preloadPublishStep,
	},
	[STEP_IDENTIFIER_NAME.REACH]: {
		component: ReachLoader,
		preload: preloadReachStep,
	},
};
